// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root{--color-alerts-green: #039b03;--color-alerts-orange: #ff6200;--color-alerts-red: #dd0000;--color-alerts-yellow: #ffb225;--color-primary-blueLink: #067eeb;--color-primary-newScoutingBlue: #005696;--color-primary-oldScoutingBlue: #003f87;--color-primary-scoutingRed: #ce1126;--color-primary-scoutingWarmGray: #515354;--color-primary-tan: #d6cebd;--color-primary-white: #ffffff;--color-programs-SBSA-olive: #243e26;--color-programs-SBSA-red: #ce1126;--color-programs-SBSA-tan: #d6cebd;--color-programs-SBSA-darkTan: #ad9d7b;--color-programs-cubScouts-blue: #003f87;--color-programs-cubScouts-yellow: #fdc116;--color-programs-exploring-darkGray: #898b8e;--color-programs-exploring-darkPurple: #221850;--color-programs-exploring-lightBlue: #aee3ff;--color-programs-exploring-lightGray: #efefef;--color-programs-exploring-mediumBlue: #0c7cff;--color-programs-exploring-red: #ef1e22;--color-programs-exploring-yellow: #e6b323;--color-programs-seaScouts-darkBlue: #003366;--color-programs-seaScouts-lightBlue: #9ab3d5;--color-programs-seaScouts-yellow: #fed12f;--color-programs-venturing-green: #0d7549;--color-programs-venturing-yellow: #fbd536;--color-shades-accordionContent: #fafafa;--color-shades-chips: #cdd4dc;--color-shades-grayButtons: #969897;--color-shades-listHeaders: #cccccc;--color-shades-outlines: #e6e6e6;--color-shades-pageBackground: #f2f2f2;--color-text-dark: #1a1a1a;--color-text-disabled: #bdbebe;--color-text-light: #808080;--color-text-medium: #333333;--color-text-regular: #515354;--color-white: #ffffff;--color-primary: #003f87;--color-primary-hover: rgb(25.5, 82.2, 147);--color-primary-active: rgb(51, 101.4, 159);--color-text-heading: #003f87;--color-red: #dd0000;--color-green: #039b03;--color-orange: #ff6200;--color-yellow: #ffb225;--color-blue: #067eeb;--color-success: #039b03;--color-error: #dd0000;--color-warning: #ff6200;--color-info: #067eeb;--color-text-muted: #808080;--color-item-hover-bg: rgb(234.6, 245.4, 254.4);--color-segmented-active-bg: rgb(192.75, 222.75, 250);--color-segmented-hover-bg: rgb(205.2, 229.2, 251);--checkbox-border-color-hover: rgb(80.7, 164.7, 241);--checkbox-border-color-disabled: #bdbebe;--color-table-header-bg: #515354;--color-table-header-text: #ffffff;--color-table-header-icon: rgba(255, 255, 255, 0.25);--color-table-header-icon-hover: rgba(255, 255, 255, 0.6);--color-table-header-filter-hover-bg: rgba(255, 255, 255, 0.15);--color-table-header-sort-active-bg: #515354;--color-table-header-sort-active: rgba(255, 255, 255, 0.85);--color-table-header-filter-active: rgba(255, 255, 255, 0.85);--color-table-header-sort-hover-bg: #515354;--color-table-header-split: #515354;--sbui-font-primary: Roboto, system-ui, -apple-system, Segoe UI, Helvetica Neue, Noto Sans, Liberation Sans, Arial, sans-serif;--sbui-font-secondary: Roboto Slab, Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace;--sbui-font-mono: SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace}`, "",{"version":3,"sources":["webpack://./packages/scouting-ui/lib/scss/_exports.scss"],"names":[],"mappings":"AAmBA,MAEI,6BAAA,CAAA,8BAAA,CAAA,2BAAA,CAAA,8BAAA,CAAA,iCAAA,CAAA,wCAAA,CAAA,wCAAA,CAAA,oCAAA,CAAA,yCAAA,CAAA,4BAAA,CAAA,8BAAA,CAAA,oCAAA,CAAA,kCAAA,CAAA,kCAAA,CAAA,sCAAA,CAAA,wCAAA,CAAA,0CAAA,CAAA,4CAAA,CAAA,8CAAA,CAAA,6CAAA,CAAA,6CAAA,CAAA,8CAAA,CAAA,uCAAA,CAAA,0CAAA,CAAA,4CAAA,CAAA,6CAAA,CAAA,0CAAA,CAAA,yCAAA,CAAA,0CAAA,CAAA,wCAAA,CAAA,6BAAA,CAAA,mCAAA,CAAA,mCAAA,CAAA,gCAAA,CAAA,sCAAA,CAAA,0BAAA,CAAA,8BAAA,CAAA,2BAAA,CAAA,4BAAA,CAAA,6BAAA,CAME,sBAAA,CAAA,wBAAA,CAAA,2CAAA,CAAA,2CAAA,CAAA,6BAAA,CAAA,oBAAA,CAAA,sBAAA,CAAA,uBAAA,CAAA,uBAAA,CAAA,qBAAA,CAAA,wBAAA,CAAA,sBAAA,CAAA,wBAAA,CAAA,qBAAA,CAAA,2BAAA,CAAA,+CAAA,CAAA,qDAAA,CAAA,kDAAA,CAAA,oDAAA,CAAA,yCAAA,CAAA,gCAAA,CAAA,kCAAA,CAAA,oDAAA,CAAA,yDAAA,CAAA,+DAAA,CAAA,4CAAA,CAAA,2DAAA,CAAA,6DAAA,CAAA,2CAAA,CAAA,mCAAA,CAIJ,8HAAA,CACA,oGAAA,CACA,kGAAA","sourcesContent":["@use 'sass:string';\n@use 'sass:meta';\n@use 'variables';\n@use 'bsaColors.scss';\n\n$exported: meta.module-variables('variables');\n$bsaColors: meta.module-variables('bsaColors');\n\n/** This exports variables to be used in JS. Make sure there are no maps */\n:export {\n  @each $varName, $value in $exported {\n    #{$varName}: #{$value};\n  }\n  @each $varName, $value in $bsaColors {\n    #{$varName}: #{$value};\n  }\n}\n\n/** this generates CSS vars per color */\n:root {\n  @each $color, $value in $bsaColors {\n    --#{$color}: #{$value};\n  }\n\n  @each $var, $value in $exported {\n    $isColor: string.index($var, 'color-');\n    @if $isColor {\n      --#{$var}: #{$value};\n    }\n  }\n\n  --sbui-font-primary: #{variables.$font-family-sans-serif};\n  --sbui-font-secondary: #{variables.$font-family-serif};\n  --sbui-font-mono: #{variables.$font-family-mono};\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"border-radius": `12px`,
	"border-radius-sm": `8px`,
	"icon-size": `22px`,
	"icon-size-sm": `16px`,
	"font-family-sans-serif": `Roboto, system-ui, -apple-system, Segoe UI, Helvetica Neue, Noto Sans, Liberation Sans, Arial, sans-serif`,
	"font-family-serif": `Roboto Slab, Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace`,
	"font-family-mono": `SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace`,
	"font-primary": `Roboto, system-ui, -apple-system, Segoe UI, Helvetica Neue, Noto Sans, Liberation Sans, Arial, sans-serif`,
	"font-serif": `Roboto Slab, Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace`,
	"font-mono": `SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace`,
	"font-size-sm": `10px`,
	"color-white": `#ffffff`,
	"color-primary": `#003f87`,
	"color-primary-hover": `rgb(25.5, 82.2, 147)`,
	"color-primary-active": `rgb(51, 101.4, 159)`,
	"color-text-heading": `#003f87`,
	"color-red": `#dd0000`,
	"color-green": `#039b03`,
	"color-orange": `#ff6200`,
	"color-yellow": `#ffb225`,
	"color-blue": `#067eeb`,
	"color-success": `#039b03`,
	"color-error": `#dd0000`,
	"color-warning": `#ff6200`,
	"color-info": `#067eeb`,
	"color-text-muted": `#808080`,
	"spacing-1": `2px`,
	"spacing-2": `4px`,
	"spacing-3": `8px`,
	"spacing-4": `12px`,
	"spacing-5": `16px`,
	"spacing-6": `20px`,
	"spacing-7": `24px`,
	"spacing-8": `32px`,
	"spacing-9": `40px`,
	"spacing-10": `48px`,
	"spacing-11": `56px`,
	"spacing-12": `64px`,
	"spacing-13": `72px`,
	"spacing-14": `80px`,
	"spacing-xxs": `2px`,
	"spacing-xs": `4px`,
	"spacing-sm": `8px`,
	"spacing-md": `16px`,
	"spacing-lg": `24px`,
	"spacing-xl": `32px`,
	"spacing-xxl": `40px`,
	"button-height": `48px`,
	"button-height-sm": `32px`,
	"button-height-lg": `56px`,
	"color-item-hover-bg": `rgb(234.6, 245.4, 254.4)`,
	"color-segmented-active-bg": `rgb(192.75, 222.75, 250)`,
	"color-segmented-hover-bg": `rgb(205.2, 229.2, 251)`,
	"input-height": `56px`,
	"input-height-sm": `48px`,
	"input-active-bg": `#ddeffe`,
	"checkbox-size": `24px`,
	"checkbox-border-color": `#bdbebe`,
	"checkbox-border-color-hover": `rgb(80.7, 164.7, 241)`,
	"checkbox-border-color-disabled": `#bdbebe`,
	"color-table-header-bg": `#515354`,
	"color-table-header-text": `#ffffff`,
	"color-table-header-icon": `rgba(255, 255, 255, 0.25)`,
	"color-table-header-icon-hover": `rgba(255, 255, 255, 0.6)`,
	"color-table-header-filter-hover-bg": `rgba(255, 255, 255, 0.15)`,
	"color-table-header-sort-active-bg": `#515354`,
	"color-table-header-sort-active": `rgba(255, 255, 255, 0.85)`,
	"color-table-header-filter-active": `rgba(255, 255, 255, 0.85)`,
	"color-table-header-sort-hover-bg": `#515354`,
	"color-table-header-split": `#515354`,
	"pagination-size-changer-height": `36px`,
	"pagination-size-changer-height-sm": `30px`,
	"color-alerts-green": `#039b03`,
	"color-alerts-orange": `#ff6200`,
	"color-alerts-red": `#dd0000`,
	"color-alerts-yellow": `#ffb225`,
	"color-primary-blueLink": `#067eeb`,
	"color-primary-newScoutingBlue": `#005696`,
	"color-primary-oldScoutingBlue": `#003f87`,
	"color-primary-scoutingRed": `#ce1126`,
	"color-primary-scoutingWarmGray": `#515354`,
	"color-primary-tan": `#d6cebd`,
	"color-primary-white": `#ffffff`,
	"color-programs-SBSA-olive": `#243e26`,
	"color-programs-SBSA-red": `#ce1126`,
	"color-programs-SBSA-tan": `#d6cebd`,
	"color-programs-SBSA-darkTan": `#ad9d7b`,
	"color-programs-cubScouts-blue": `#003f87`,
	"color-programs-cubScouts-yellow": `#fdc116`,
	"color-programs-exploring-darkGray": `#898b8e`,
	"color-programs-exploring-darkPurple": `#221850`,
	"color-programs-exploring-lightBlue": `#aee3ff`,
	"color-programs-exploring-lightGray": `#efefef`,
	"color-programs-exploring-mediumBlue": `#0c7cff`,
	"color-programs-exploring-red": `#ef1e22`,
	"color-programs-exploring-yellow": `#e6b323`,
	"color-programs-seaScouts-darkBlue": `#003366`,
	"color-programs-seaScouts-lightBlue": `#9ab3d5`,
	"color-programs-seaScouts-yellow": `#fed12f`,
	"color-programs-venturing-green": `#0d7549`,
	"color-programs-venturing-yellow": `#fbd536`,
	"color-shades-accordionContent": `#fafafa`,
	"color-shades-chips": `#cdd4dc`,
	"color-shades-grayButtons": `#969897`,
	"color-shades-listHeaders": `#cccccc`,
	"color-shades-outlines": `#e6e6e6`,
	"color-shades-pageBackground": `#f2f2f2`,
	"color-text-dark": `#1a1a1a`,
	"color-text-disabled": `#bdbebe`,
	"color-text-light": `#808080`,
	"color-text-medium": `#333333`,
	"color-text-regular": `#515354`
};
export default ___CSS_LOADER_EXPORT___;
